import * as React from "react";
import Image, {ImageObject} from "/src/components/image/Image";
import {css} from "/src/utils/utils";
import * as styles from "./loop-lable.module.scss";

interface Props
  extends Pick<
    Queries.CarouselSlideFragmentFragment,
    "highlightedIcon" | "timelineButtonText"
  > {
  isActive: boolean;
  position: string;
}

export function LoopLabel(props: Props) {
  const {highlightedIcon, isActive, position, timelineButtonText} = props;

  if (!highlightedIcon) {
    return null;
  }

  return (
    <div
      className={css(
        styles.loopLabel,
        styles[
          `loopLabel${position.charAt(0).toUpperCase()}${position.slice(1)}`
        ],
        isActive ? styles.loopLabelVisible : ""
      )}
    >
      <div className={styles.loopLabel__icon}>
        <Image image={highlightedIcon as ImageObject} />
      </div>
      <h4 className={css("h4", styles.loopLabel__timelineButtonText)}>
        {timelineButtonText}
      </h4>
    </div>
  );
}
